module.exports = __webpack_public_path__ + "img/gwbged.cba68cdf.png";